import { IUpgradeFaq } from './faqHelpers';
import { UPGRADE_STEPS, MembershipTier } from '@/lib/constants/maverick';

export const upgradeFaqs: Record<string, IUpgradeFaq> = {
  whyIsMyNextRenewal: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: false,
      [UPGRADE_STEPS.OPTIONS]: {
        [MembershipTier.ONE]: false,
        [MembershipTier.PEAK]: false,
        [MembershipTier.LIFE]: true,
      },
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  are4BandsCompatible: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  howDoIMoveToTheWhoopOne: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  whatDoIDoWithPrevious: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: true,
    },
  },
  doIGetPaidIfIGiveMyDevice: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: true,
    },
  },
  whatIsWhoopMG: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  inWhatRegionsAreHeart: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: {
        [MembershipTier.ONE]: false,
        [MembershipTier.PEAK]: false,
        [MembershipTier.LIFE]: true,
      },
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  imNotSeeingUpgradeFee: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: false,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  howDoUpgradesDowngradesWork: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: false,
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  whenWillMyDeviceShip: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: true,
      [UPGRADE_STEPS.OPTIONS]: true,
      [UPGRADE_STEPS.UPCYCLE]: false,
    },
  },
  doIHaveToGift: {
    pages: {
      [UPGRADE_STEPS.UPGRADE]: false,
      [UPGRADE_STEPS.OPTIONS]: false,
      [UPGRADE_STEPS.UPCYCLE]: true,
    },
  },
};